module.exports = __webpack_public_path__ + "static/media/industry_leading_dark.ed042f8b.svg";